const milestones = [
  {
    year: '2009',
    title: 'Začiatok v IT',
    desc: 'Začal som sa pohybovať v IT svete - správa systémov, CRM riešenia, technická podpora. Naučil som sa, že dobrá technológia musí slúžiť ľuďom, nie naopak.',
    icon: 'ri-computer-line',
  },
  {
    year: '2021',
    title: 'Prvé weby a Boostio',
    desc: 'Po rokoch v IT sektore som začal tvoriť weby pre lokálne firmy v okolí Prešova. IT skúsenosti mi dali obrovskú výhodu - rozumiem nielen dizajnu, ale aj technickému pozadiu každého projektu.',
    icon: 'ri-rocket-2-line',
  },
  {
    year: '2022',
    title: 'Prvých 20 klientov',
    desc: 'Rast cez referencie - žiadna reklama, len výsledky. Pribudli e-shopy, CRM systémy na mieru a prvé marketingové kampane. Klienti oceňujú, že im rozumiem aj po technickej stránke.',
    icon: 'ri-store-2-line',
  },
  {
    year: '2023',
    title: 'Komplexné riešenia',
    desc: 'Rozšírenie portfólia o správu sociálnych sietí, SEO a dlhodobú spoluprácu. Priamy kontakt bez prostredníkov a osobná zodpovednosť za výsledok - to je môj štandard.',
    icon: 'ri-settings-3-line',
  },
  {
    year: '2024–25',
    title: '50+ klientov & ďalej',
    desc: 'Salenbike, ICF House, MUDr. Sivák a ďalší. Každý projekt dostáva rovnakú osobnú starostlivosť. Nový klientský portál a interné systémy - Boostio rastie ďalej.',
    icon: 'ri-arrow-up-circle-line',
  },
];

export default function AboutStory() {
  return (
    <section className="bg-zinc-950 py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-16 xl:gap-24">

          {/* Left - heading */}
          <div className="lg:w-80 flex-shrink-0">
            <p className="text-orange-400 text-xs uppercase tracking-widest font-semibold mb-3">Môj príbeh</p>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-6">
              Odkiaľ<br />som prišiel
            </h2>
            <p className="text-zinc-500 text-base leading-relaxed">
              Nie som korporácia s poschodiami reportov. Som človek, ktorému záleží na tom, čo robí - a na výsledkoch každého klienta.
            </p>
            <div className="mt-8 h-px w-16 bg-orange-500/40" />
          </div>

          {/* Right - timeline */}
          <div className="flex-1 relative">
            {/* vertical line */}
            <div className="absolute left-5 top-0 bottom-0 w-px bg-zinc-800/70 hidden md:block" />

            <div className="space-y-10">
              {milestones.map((m, i) => (
                <div key={i} className="flex gap-8 group">
                  {/* Icon circle */}
                  <div className="hidden md:flex flex-shrink-0 w-10 h-10 rounded-full bg-zinc-900 border border-zinc-700 group-hover:border-orange-500/50 items-center justify-center relative z-10 transition-all duration-300">
                    <i className={`${m.icon} text-orange-400 text-base`} />
                  </div>
                  {/* Content */}
                  <div className="bg-zinc-900/40 border border-zinc-800/50 group-hover:border-zinc-700/80 rounded-2xl p-6 flex-1 transition-all duration-300">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-orange-400 font-mono font-bold text-sm bg-orange-500/10 px-2.5 py-0.5 rounded-md border border-orange-500/20 whitespace-nowrap">
                        {m.year}
                      </span>
                      <h3 className="text-white font-bold text-lg">{m.title}</h3>
                    </div>
                    <p className="text-zinc-400 text-sm leading-relaxed">{m.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
